import { DateHistoryItem } from "@/components/history/items/commonHistoryItems";

export const AgentCompletedEducationDetailHistoryItemsMap = new Map<string, (value: any) => React.JSX.Element>([
  ["introductionWebinarDate", DateHistoryItem],
  ["financialAcademyDate", DateHistoryItem],
  ["personalAcademyDate", DateHistoryItem],
]);
